import React from "react";
import { useParams } from "react-router";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useGetServiceObjectDetailQuery } from "./queries";
import { AttachmentsGallery, PageHeading, useAuth } from "../../components";
import ServiceObjectOrdersTable from "./components/detail/ServiceObjectOrdersTable";
import ServiceObjectInfoBox from "./components/detail/ServiceObjectInfoBox";
import RequestCreateAlert from "../requests/components/RequestCreateAlert";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import ServiceObjectNextRevisions from "./components/detail/ServiceObjectNextRevisions";

type ServiceObjectRouteParams = "serviceObjectId";

const ServiceObjectDetailPage: React.FC = (): React.ReactElement => {
  const params = useParams<ServiceObjectRouteParams>();
  const { user } = useAuth();

  const { tRequest } = useCustomTranslation();

  const query = useGetServiceObjectDetailQuery(params.serviceObjectId);

  const serviceObjectDetail = query.data;

  return (
    <ContentWrapper
      loading={query.isLoading || !serviceObjectDetail}
      htmlTitle={serviceObjectDetail?.name}
    >
      {serviceObjectDetail && (
        <>
          <PageHeading
            title={serviceObjectDetail.name}
            backButtonPath="serviceObjects"
            className="sm:mb-7"
          />
          <ServiceObjectInfoBox serviceObjectDetail={serviceObjectDetail} />
          <ServiceObjectNextRevisions
            nextRevisionCategories={serviceObjectDetail.revisionCategories}
          />
          <ServiceObjectOrdersTable serviceObjectId={serviceObjectDetail.id} />
          <AttachmentsGallery
            className="mt-14"
            attachments={serviceObjectDetail.attachments}
          />
          <RequestCreateAlert
            title={tRequest("cp_service_object_title")}
            description={tRequest("cp_service_object_description")}
            requestPageParams={{
              allowedRequestTypes:
                user?.customerId === serviceObjectDetail.owningCustomerId
                  ? ["ServiceObjectUpdate", "OrderRequestFromOwner"]
                  : ["ServiceObjectUpdate", "OrderRequest"],
              serviceObject: {
                label: serviceObjectDetail.name,
                value: serviceObjectDetail.id,
              },
              customer: {
                label: serviceObjectDetail.customerName,
                value: serviceObjectDetail.customerId,
              },
            }}
          />
        </>
      )}
    </ContentWrapper>
  );
};

export default ServiceObjectDetailPage;
